// @flow
import * as React from 'react';

import {
  CONSULTATION_MAIN_FLOW,
  OPINION_MAIN_FLOW,
  PROFILE_LOGIN,
} from '@routes';

import { healthGPTRoute } from '@lib/healthGPTRoute';

import { withTranslation, Link } from '@i18n';
import NavigationLink from '../NavigationLink';

import { StyledLinksNavigation, StyledButtonSignInOut } from './styles';
import { LoggedInDropdown } from '../LoginSignInButtons/index';


const CurefyNavigationLinks = ({
  t, invertCta, isLoggedIn, doLogout, username, pathname
}): React.Node => (
  <StyledLinksNavigation>
    <NavigationLink label={t('HealthGPT')} route={healthGPTRoute} />
    <NavigationLink label={t('OnlineConsultationSecond')} route={CONSULTATION_MAIN_FLOW} />
    {/* {!isLoggedIn && <LoginDropdown doLogin={doLogin} />} */}
    {isLoggedIn ? (
      <LoggedInDropdown doLogout={doLogout} username={username} pathname={pathname} />
    ) : (
      <>
        <NavigationLink label={t('Login')} route={PROFILE_LOGIN} />

        {/* <StyledButtonSignInOut inverted={invertCta} onClick={() => setModalOpen(true)}> */}
        <Link href={OPINION_MAIN_FLOW} params={{ path: 'department' }} passHref>
          <StyledButtonSignInOut inverted={invertCta}>
            {t('GetStarted')}
          </StyledButtonSignInOut>
        </Link>

        {/* { flow && <FlowModal />} */}
      </>
    )}

  </StyledLinksNavigation>
);
export default withTranslation('Navigation')(CurefyNavigationLinks);
